import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { totaleFormat } from '@shared/shared-functions';
import DataSource from 'devextreme/data/data_source';
import { DataToSendDichiarazione, StatoDichiarazione } from '../../dischiarazione.models';
import { DichiarazioneService } from '../../services/dichiarazione.service';

@Component({
    selector: 'app-dettagli-quadro-lm-45',
    templateUrl: './dettagli-quadro-lm-45.component.html',
    styleUrls: ['./dettagli-quadro-lm-45.component.scss'],
})
export class DettagliQuadroLm45Component implements OnInit {
    statoDichiarazioneTemplate = StatoDichiarazione;

    dettagliAccontiVersatiDichiarazioneAperta: DataSource;

    get cellIsProvvisoria() {
        return this.dettagliLm45.cellId.endsWith('provvisoria');
    }

    constructor(
        public dialogRef: MatDialogRef<DettagliQuadroLm45Component>,
        @Inject(MAT_DIALOG_DATA)
        public dettagliLm45: { statoDichiarazione: StatoDichiarazione; cellId: string; dataToSendDichiarazione: DataToSendDichiarazione },
        private dichiarazioneService: DichiarazioneService
    ) {}

    ngOnInit() {
        this.dettagliAccontiVersatiDichiarazioneAperta = new DataSource({
            load: () =>
                this.dichiarazioneService
                    .getDettagliAccontiVersati(this.dettagliLm45.dataToSendDichiarazione.forfettarioId, this.dettagliLm45.dataToSendDichiarazione.anno)
                    .toPromise()
                    .then(dettagliAccontiVersati => {
                        return {
                            data: [
                                {
                                    descrizione: `1° acconto da versare calcolato in UNICO${this.dettagliLm45.dataToSendDichiarazione.anno}`,
                                    importo: dettagliAccontiVersati.primoAccontoVersato,
                                },
                                {
                                    descrizione: `2° acconto da versare calcolato in UNICO${this.dettagliLm45.dataToSendDichiarazione.anno}`,
                                    importo: dettagliAccontiVersati.secondoAccontoVersato,
                                },
                            ],
                        };
                    }),
        });
    }

    totaleImportoFormat(cellInfo) {
        return totaleFormat(cellInfo);
    }
}
